import { ParsedAttributes } from '../types';

export const parseAttributes = (attributes: string | object | null | undefined): ParsedAttributes => {
  if (!attributes) return {};
  if (typeof attributes === 'object') {
    if ('type' in attributes && 'msg' in attributes) return {};
    return attributes as ParsedAttributes;
  }
  try {
    const parsed = JSON.parse(attributes);
    if (typeof parsed !== 'object' || parsed === null) return {};
    return parsed;
  } catch {
    return {};
  }
};

export const formatSpeed = (speed: number | undefined | null): string => {
  return `${Math.round(speed ?? 0)} km/h`;
};

export const formatVoltage = (voltage: number | undefined | null): string => {
  return `${(voltage ?? 0).toFixed(1)}V`;
};

export const formatDistance = (meters: number | undefined | null): string => {
  const m = meters ?? 0;
  if (m < 1000) return `${Math.round(m)}m`;
  return `${(m / 1000).toFixed(2)} km`;
};

export const getOperatorName = (code: number | undefined | null): string => {
  const operators: { [key: number]: string } = {
    26001: 'Plus',
    26002: 'T-Mobile',
    26003: 'Orange',
    26006: 'Play',
  };
  return operators[code ?? 0] || `${code ?? '?'}`;
};
